import React from 'react';
import { ListItem, TextButton, Tooltip } from '@ds';
import styles from './ViewSelect.module.scss';
import { DSInformationIcon } from '@design-system/icons';
import { ViewItemData } from './utils';
import { AUTO_GENERATED_OPTION_ID } from '@shared/constants';

type FrozenContentProps = {
  onRegenerate?: () => void;
};
const FrozenContent: React.FC<FrozenContentProps> = ({ onRegenerate }) => {
  const onClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    e.preventDefault();
    e.stopPropagation();
    onRegenerate?.();
  };

  return (
    <div className={styles.autogenBottomContainer}>
      <div>
        Updates paused{' '}
        <Tooltip
          content="Syncing is paused and new panels will not be shown.  Regenerating the view updates panels and discards manual edits. You can save your changes by duplicating the view."
          className={styles.autogenStatusInfo}
        >
          <DSInformationIcon />
        </Tooltip>
      </div>
      <TextButton
        type="tertiary"
        size="small"
        data-test="personal-view-regenerate-btn"
        onClick={onClick}
      >
        Regenerate
      </TextButton>
    </div>
  );
};

const DefaultContent = () => {
  return (
    <>
      Up to date{' '}
      <Tooltip
        content="When you log new metrics, they will appear in this view"
        className={styles.autogenStatusInfo}
      >
        <DSInformationIcon />
      </Tooltip>
    </>
  );
};

type ViewSelectAutogenOptionProps = {
  onRegenerateDefaultView: () => void;
  actionList: React.ReactNode;
  viewIndicator: React.ReactNode;
  data: ViewItemData;
  selectedViewId?: string | null;
  onClick: () => void;
};

const ViewSelectAutogenOption: React.FC<ViewSelectAutogenOptionProps> = ({
  onRegenerateDefaultView,
  actionList,
  viewIndicator,
  data,
  selectedViewId,
  onClick
}) => {
  return (
    <div className={styles.optionContainer}>
      <ListItem
        active={
          selectedViewId === data.id ||
          selectedViewId === AUTO_GENERATED_OPTION_ID
        }
        onClick={onClick}
        data-test="view-select-personal-view-item"
      >
        <ListItem.Text
          primary={
            <>
              {data.name}
              {data.frozen && viewIndicator}
            </>
          }
          secondary={
            data.frozen ? (
              <FrozenContent onRegenerate={onRegenerateDefaultView} />
            ) : (
              <DefaultContent />
            )
          }
        />
        {actionList}
      </ListItem>
    </div>
  );
};

export default ViewSelectAutogenOption;
